// Resolves the signed-in portal account. The email is written to sessionStorage
// by the sign-in screen, so each person sees their own identity in the sidebar.

export type PortalAccount = {
  email: string
  role: string
  isAdmin: boolean
  name: string
  avatarUrl?: string
  initial: string
}

// Domains that belong to the ManyCo team rather than a brand.
const teamDomains = ['manyco.ai', 'themanycompany.com']

const knownPeople: Record<string, { name: string; role: string; avatarUrl?: string }> = {
  'rich@manyco.ai': {
    name: 'Rich Amsinger',
    role: 'Admin',
    avatarUrl: 'https://cdn.magicpatterns.com/uploads/xhitauzhQ9Dm5eEx8AXjnW/RichAmsingerHeadshot.jpg',
  },
  'carolyn@themanycompany.com': { name: 'Carolyn Reid', role: 'Admin' },
}

const fallbackEmail = 'rich@manyco.ai'

export function getPortalAccount(): PortalAccount {
  const stored = typeof window !== 'undefined' ? window.sessionStorage.getItem('manyco.portalEmail') : null
  const email = (stored || fallbackEmail).trim().toLowerCase()
  const domain = email.split('@')[1] ?? ''
  const isAdmin = teamDomains.includes(domain)
  const known = knownPeople[email]
  const localPart = email.split('@')[0] ?? ''
  const name =
    known?.name ??
    localPart
      .split(/[._-]/)
      .filter(Boolean)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ')

  return {
    email,
    name: name || email,
    role: known?.role ?? (isAdmin ? 'Team' : 'Brand'),
    isAdmin,
    avatarUrl: known?.avatarUrl,
    initial: (name || email).charAt(0).toUpperCase(),
  }
}
